import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook pour détecter automatiquement le slug de la page courante
 * VERSION DYNAMIQUE - Plus de mapping manuel !
 * 
 * ✅ Convertit automatiquement l'URL en slug
 * ✅ Compatible avec toutes les pages créées en Admin
 * ✅ Plus besoin de maintenance manuelle
 */

const useCurrentPageSlug = () => {
  const location = useLocation();
  
  const pageSlug = useMemo(() => {
    const pathname = location.pathname;
    
    console.log('🔍 [useCurrentPageSlug] Current URL:', pathname);
    
    // Cas spéciaux (pages statiques)
    if (pathname === '/' || pathname === '/landingpage') {
      console.log('   → Slug: page-landing (static)');
      return 'page-landing';
    }
    
    // Pour les URLs /dashboard/* on retourne le slug complet
    // Ex: /dashboard/nouveautes_en_cours → /dashboard/nouveautes_en_cours
    // L'API backend accepte les slugs avec /dashboard/
    if (pathname.startsWith('/dashboard/')) {
      console.log('   → Slug:', pathname);
      return pathname;
    }
    
    // Pour /dashboard seul
    if (pathname === '/dashboard') {
      console.log('   → Slug: /dashboard');
      return '/dashboard';
    }
    
    // Pour toutes les autres URLs publiques
    // Ex: /mentions-legales → /mentions-legales
    const slug = pathname.startsWith('/') ? pathname : `/${pathname}`;
    console.log('   → Slug:', slug);
    return slug;
    
  }, [location.pathname]);
  
  return pageSlug;
};

export default useCurrentPageSlug;
